import {
  Component,
  Input,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
@Component({
    selector: 'bergh-preview-new-map',
    templateUrl: './preview-new-map.component.html',
    styleUrls: ['./preview-new-map.component.scss'],
    standalone: false
})
export class PreviewNewMapComponent implements AfterViewInit {
  @ViewChild('background') public backgroundRef: ElementRef;
  @ViewChild('foreground') public foregroundRef: ElementRef;
  @ViewChild('oldmap') public oldMapRef: ElementRef;
  @ViewChild('newmap') public newMapRef: ElementRef;
  @Input() public oldimgsrc;
  @Input() public newimgsrc;
  @Output() public onSave: EventEmitter<string> = new EventEmitter();
  @Output() public isMapReplaced: EventEmitter<boolean> = new EventEmitter();
  @Output() public onClose: EventEmitter<boolean> = new EventEmitter();

  public showTool: boolean = false;
  public clickedOnSave: boolean = false;

  //default alpha
  public bgalpha = 0.5;
  public fgalpha = 0.5;

  //setup canvas letiables
  public scaledoldmapwidth = 7020;
  public scalednewmapwidth = 7020;
  public scaledoldmapheight = 4966;
  public scalednewmapheight = 4966;

  //get the background and foreground contexts
  public bgimgsrc;
  public fgimgsrc;
  public background;
  public bgcontext;
  public foreground;
  public fgcontext;
  public finalImage;

  ngAfterViewInit(): void {
    this.setElementRef();
  }

  public setElementRef() {
    this.background = this.backgroundRef.nativeElement;
    this.foreground = this.foregroundRef.nativeElement;

    this.bgcontext = this.background.getContext('2d');
    this.fgcontext = this.foreground.getContext('2d');
  }

  public setupCanvas() {
    this.showTool = true;
    this.isMapReplaced.emit(true);
    const oldmap = this.oldMapRef.nativeElement;
    const newmap = this.newMapRef.nativeElement;
    const oldmapwidth = oldmap.naturalWidth;
    const oldmapheight = oldmap.naturalHeight;
    const newmapwidth = newmap.naturalWidth;
    const newmapheight = newmap.naturalHeight;
    const canvaswidth = newmapwidth;
    this.scaledoldmapwidth = canvaswidth;
    const canvasheight = Math.round((canvaswidth * oldmapheight) / oldmapwidth);
    this.scaledoldmapheight = canvasheight;
    const scaledcanvaswidth = 1000;
    const scaledcanvasheight = Math.round(
      (scaledcanvaswidth * canvasheight) / canvaswidth
    );
    this.scalednewmapwidth = newmapwidth;
    this.scalednewmapheight = newmapheight;
    this.bgimgsrc = oldmap.src;
    this.fgimgsrc = newmap.src;
    this.background.width = canvaswidth;
    this.background.height = canvasheight;
    this.background.style.width = scaledcanvaswidth + 'px';
    this.background.style.height = scaledcanvasheight + 'px';
    this.foreground.width = canvaswidth;
    this.foreground.height = canvasheight;
    this.foreground.style.width = scaledcanvaswidth + 'px';
    this.foreground.style.height = scaledcanvasheight + 'px';
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.bgcontext.clearRect(
      0,
      0,
      this.background.width,
      this.background.height
    );
    this.bgcontext.globalAlpha = 0.5;
    this.fgcontext.globalAlpha = 0.5;
    this.bgcontext.save();
    this.fgcontext.save();
    this.loadBg();
    this.loadFg();
  }

  public loadBg() {
    let bgimageObj = new Image();
    bgimageObj.onload = () => {
      this.bgcontext.drawImage(
        bgimageObj,
        0,
        0,
        this.scaledoldmapwidth,
        this.scaledoldmapheight
      );
    };
    bgimageObj.src = this.bgimgsrc;
  }

  public loadFg() {
    let fgimageObj = new Image();
    fgimageObj.crossOrigin = 'anonymous';
    fgimageObj.onload = () => {
      this.fgcontext.drawImage(
        fgimageObj,
        0,
        0,
        this.scalednewmapwidth,
        this.scalednewmapheight
      );
    };

    fgimageObj.src = this.fgimgsrc;
  }

  public save() {
    this.clickedOnSave = true;
    this.foreground.style.backgroundColor = '#ffffff';
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.globalAlpha = 1;
    this.loadFg();
    this.fgcontext.globalCompositeOperation = 'destination-under';
    this.fgcontext.fillStyle = 'white';
    const fillwidth = this.foreground.width + 4000;
    const fillheight = this.foreground.height + 4000;
    this.fgcontext.fillRect(-2000, -2000, fillwidth, fillheight);
  }

  public saveAndclose(): void {
    const image = this.foreground.toDataURL('image/jpeg');
    this.onSave.emit(image);
  }

  public closed(): void {
    this.onClose.emit(false);
  }
  // OPERATION FUNCTIONS FOR X DIRECTION
  public moveup() {
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.translate(0, -200);
    this.loadFg();
  }
  public movedown() {
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.translate(0, 200);
    this.loadFg();
  }
  public movepxup() {
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.translate(0, -1);
    this.loadFg();
  }
  public movepxdown() {
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.translate(0, 1);
    this.loadFg();
  }

  // OPERATION FUNCTIONS FOR Y DIRECTION
  public moveleft() {
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.translate(-200, 0);
    this.loadFg();
  }
  public moveright() {
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.translate(200, 0);
    this.loadFg();
  }
  public movepxleft() {
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.translate(-1, 0);
    this.loadFg();
  }
  public movepxright() {
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.translate(1, 0);
    this.loadFg();
  }

  // OPERATION FUNCTIONS FOR TRANSFORMATION
  public rotate() {
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.translate(
      this.foreground.width / 2,
      this.foreground.height / 2
    );
    this.fgcontext.rotate(Math.PI / 2);
    this.fgcontext.translate(
      -this.foreground.width / 2,
      -this.foreground.height / 2
    );
    this.loadFg();
  }
  public scaleup() {
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.scale(1.01, 1.01);
    this.loadFg();
  }
  public scaledown() {
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.scale(0.99, 0.99);
    this.loadFg();
  }

  // OPERATION FUNCTIONS FOR ZOOMING
  public zoomin() {
    const fnewwidth = this.foreground.offsetWidth * 2;
    const fnewheight = this.foreground.offsetHeight * 2;
    const bnewwidth = this.background.offsetWidth * 2;
    const bnewheight = this.background.offsetHeight * 2;
    this.foreground.style.width = fnewwidth + 'px';
    this.foreground.style.height = fnewheight + 'px';
    this.background.style.width = bnewwidth + 'px';
    this.background.style.height = bnewheight + 'px';
  }
  public zoomout() {
    const fnewwidth = this.foreground.offsetWidth / 2;
    const fnewheight = this.foreground.offsetHeight / 2;
    const bnewwidth = this.background.offsetWidth / 2;
    const bnewheight = this.background.offsetHeight / 2;
    this.foreground.style.width = fnewwidth + 'px';
    this.foreground.style.height = fnewheight + 'px';
    this.background.style.width = bnewwidth + 'px';
    this.background.style.height = bnewheight + 'px';
  }

  // OPERATION FUNCTION FOR ALPHA MANIPULATION
  public bgalphaup() {
    if (this.bgalpha < 1) {
      this.bgalpha = this.bgalpha + 0.25;
    }
    this.bgcontext.clearRect(
      0,
      0,
      this.background.width,
      this.background.height
    );
    this.bgcontext.globalAlpha = this.bgalpha;
    this.loadBg();
  }
  public bgalphadown() {
    if (this.bgalpha > 0) {
      this.bgalpha = this.bgalpha - 0.25;
    }
    this.bgcontext.clearRect(
      0,
      0,
      this.background.width,
      this.background.height
    );
    this.bgcontext.globalAlpha = this.bgalpha;
    this.loadBg();
  }
  public fgalphaup() {
    if (this.fgalpha < 1) {
      this.fgalpha = this.fgalpha + 0.25;
    }
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.globalAlpha = this.fgalpha;
    this.loadFg();
  }
  public fgalphadown() {
    if (this.fgalpha > 0) {
      this.fgalpha = this.fgalpha - 0.25;
    }
    this.fgcontext.clearRect(
      0,
      0,
      this.foreground.width,
      this.foreground.height
    );
    this.fgcontext.globalAlpha = this.fgalpha;
    this.loadFg();
  }
  public newMap() {
    this.showTool = false;
    this.isMapReplaced.emit(false);
  }
}
